import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCohortBuilderModalContext } from '../../../../../contexts/CohortBuilderModalContext';

export const useTriggerExitModal = () => {
  const navigate = useNavigate();

  const { closeDialog } = useCohortBuilderModalContext();

  const onTriggerExitModal = useCallback(
    (action: () => void) => {
      action();
      closeDialog();
    },
    [closeDialog]
  );

  const handleKeyboardAction = useCallback(
    (event: KeyboardEvent) => {
      // If the user is in an input field, don't trigger the exit modal
      const activeElement = document.activeElement as HTMLElement;
      const isInputField =
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable;

      if (isInputField) {
        return;
      }

      if (event.metaKey && event.key === 'ArrowLeft') {
        event.preventDefault();
        onTriggerExitModal(() => {
          navigate(-1);
        });
      } else if (event.metaKey && event.key === 'ArrowRight') {
        event.preventDefault();
        onTriggerExitModal(() => {
          navigate(1);
        });
      }
    },
    [navigate, onTriggerExitModal]
  );

  // TODO: handle browser back/forward buttons

  useEffect(() => {
    window.addEventListener('keydown', handleKeyboardAction);

    return () => {
      window.removeEventListener('keydown', handleKeyboardAction);
    };
  }, [handleKeyboardAction]);

  return { onTriggerExitModal };
};
